Ext.define('SA.lq.view.LocationsComboCmp', {
    alias: 'widget.lq-locations-combo',
    extend: 'SA.view.ComboButton',

    cls: 'sa-pvt-location-dropdown',
    emptyText: 'None',
    htmlEncode: false,
    menuCls: 'sa-pvt-location-dropdown-menu',
    ui: 'underline',
    valueField: 'locationStringId',

    menu: {
        defaults: {
            encodeText: false
        }
    },

    textTpl: [
        '<tpl if="values.isRadius || values.isCombo">',
            '<span class="sa-pvt-location-dropdown-icon-wrap">',
                '<svg class="sa-pvt-location-dropdown-icon">',
                    '<tpl if="isRadius">',
                        '<use href="#sa-icon-radius-location"></use>',
                    '<tpl else>',
                        '<use href="#sa-icon-combination-location"></use>',
                    '</tpl>',
                '</svg>',
            '</span>',
        '</tpl>',
        '{.:locationRenderer}'
    ],

    getItem() {
        return this.items.find(item => item.locationStringId === this.value);
    }
});